<div class="container py-4">
  <!-- Encabezado con volver y título -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div class="d-flex align-items-center gap-2">
      <button class="btn btn-outline-secondary" (click)="volverAtras()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h3 class="text-primary mb-0">
        <i class="fa-solid fa-pen-to-square me-2"></i>Editar Producto
      </h3>
    </div>
  </div>

  <!-- Card con formulario -->
  <div class="card shadow-sm border-0">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="guardar()">
        <div class="mb-3">
          <label for="nombre" class="form-label fw-bold">
            <i class="fa-solid fa-tag me-2"></i>Nombre
          </label>
          <input
            id="nombre"
            formControlName="nombre"
            class="form-control"
            placeholder="Ej: Yerba Mate"
            required
          />
        </div>

        <div class="mb-3">
          <label for="precio" class="form-label fw-bold">
            <i class="fa-solid fa-dollar-sign me-2"></i>Precio
          </label>
          <input
            id="precio"
            type="number"
            formControlName="precio"
            class="form-control"
            placeholder="Ej: 1500"
            required
            min="0"
            step="0.01"
          />
        </div>

        <div class="mb-3">
          <label for="stock" class="form-label fw-bold">
            <i class="fa-solid fa-boxes-stacked me-2"></i>Stock
          </label>
          <input
            id="stock"
            type="number"
            formControlName="stock"
            class="form-control"
            placeholder="Ej: 100"
            required
            min="0"
          />
        </div>

        <div class="mb-3">
          <label for="codigoBarras" class="form-label fw-bold">
            <i class="fa-solid fa-barcode me-2"></i>Código de Barras
          </label>
          <input
            id="codigoBarras"
            formControlName="codigoBarras"
            class="form-control"
            placeholder="Ej: 7791234567890"
            required
          />
        </div>

        <div class="d-flex gap-2 mt-4">
          <button type="submit" class="btn btn-primary" [disabled]="loading">
            <i class="fa-solid fa-floppy-disk me-2"></i>
            {{ loading ? 'Guardando...' : 'Guardar Cambios' }}
          </button>
          <button type="button" (click)="cancelar()" class="btn btn-outline-secondary">
            <i class="fa-solid fa-ban me-2"></i>Cancelar
          </button>
        </div>
      </form>

      <div *ngIf="error" class="alert alert-danger mt-3">{{ error }}</div>
    </div>
  </div>
</div>
